// extracted by mini-css-extract-plugin
export default {"model_row":"styles_model_row__kMoBN"};